// Nepali translations
export const ne: Record<string, string> = {
  'menu.dashboard': 'ड्यासबोर्ड',
  'menu.customers': 'ग्राहकहरू',
  'menu.products': 'उत्पादनहरू',
  'menu.users': 'प्रयोगकर्ताहरू',
  'menu.settings': 'सेटिङहरू',
  'menu.logout': 'लगआउट',
  'dashboard.title': 'ड्यासबोर्ड',
  'dashboard.newOrder': 'नयाँ अर्डर',
  'order.title': 'नयाँ अर्डर',
  'order.customer': 'ग्राहक',
  'order.products': 'उत्पादनहरू',
  'order.total': 'जम्मा',
  'users.title': 'प्रयोगकर्ताहरू',
  'users.name': 'नाम',
  'users.email': 'इमेल',
  'common.yes': 'हो',
  'common.no': 'होइन',
  'common.cancel': 'रद्द गर्नुहोस्',
  'common.save': 'सुरक्षित गर्नुहोस्',
  'common.search': 'खोज्नुहोस्',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'लगइन',
  'login.welcome': 'स्वागत छ, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'इमेल',
  'signup.phone': 'फोन',
  'menu.reportsAndAccounting': 'रिपोर्ट र लेखा',
  'menu.systemAndCommunication': 'प्रणाली र सञ्चार',
};